import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ListItem from '../ListItem';
import DropDown from '../DropDown';

import './index.scss';

export function formatItems(items) {
  return items.map(item => {
    const value = item.value === undefined ? item : item.value;
    const caption = item.caption === undefined ? item : item.caption;
    return { value, caption };
  });
}

export function filterItems(items, text) {
  return items.filter(
    ({ caption }) =>
      caption
        .toString()
        .toLowerCase()
        .indexOf(text.toLowerCase()) !== -1,
  );
}

export function NoData({ value }) {
  return (
    <div className="NoData">
      <ListItem>
        <p>{value}</p>
      </ListItem>
    </div>
  );
}

NoData.propTypes = {
  value: PropTypes.string.isRequired,
};

export default function Select({
  items,
  noDataPlaceholder,
  noResultsPlaceholder,
  numberOfVisibleItems,
  onSelect,
  placeholder,
  selectedValue,
  withSearch,
}) {
  const formattedItems = formatItems(items);

  const selectedValueItem = formattedItems.find(({ value }) => value === selectedValue) || {
    value: null,
    caption: null,
  };

  const [searchText, setSearchText] = useState('');

  const itemsToDisplay = filterItems(formattedItems, searchText);

  const hasData = Boolean(items.length > 0);
  const hasResults = Boolean(itemsToDisplay.length > 0);
  const hasNoResults = hasData && !hasResults;

  return (
    <div className="Select">
      <DropDown
        selectedValue={selectedValueItem.caption}
        numberOfVisibleItems={numberOfVisibleItems}
        onSearch={setSearchText}
        placeholder={placeholder}
        withSearch={withSearch && hasData}
      >
        {!hasData && <NoData value={noDataPlaceholder} />}
        {hasNoResults && <NoData value={noResultsPlaceholder} />}

        {itemsToDisplay.map(({ value, caption }) => {
          const isActive = value === selectedValueItem.value;
          return (
            <ListItem
              key={value}
              active={isActive}
              onClick={() => {
                onSelect(value);
              }}
            >
              <p>{caption}</p>
            </ListItem>
          );
        })}
      </DropDown>
    </div>
  );
}

const itemPropType = PropTypes.oneOfType([
  PropTypes.number,
  PropTypes.bool,
  PropTypes.string,
  PropTypes.exact({
    value: PropTypes.any,
    caption: PropTypes.string,
  }),
]);

Select.propTypes = {
  items: PropTypes.arrayOf(itemPropType).isRequired,
  noDataPlaceholder: PropTypes.string,
  noResultsPlaceholder: PropTypes.string,
  numberOfVisibleItems: PropTypes.number,
  onSelect: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  selectedValue: itemPropType,
  withSearch: PropTypes.bool,
};

Select.defaultProps = {
  noDataPlaceholder: 'No data',
  noResultsPlaceholder: 'No results',
  numberOfVisibleItems: 5,
  placeholder: '-- Select an item --',
  selectedValue: null,
  withSearch: false,
};
